<script>
import {
  CurrentSubscriptionElementMixin,
} from "%/dynamic-component-editor/standard-components/current-subscription/current-subscription-element-mixin";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";

export default {
  name: "CurrentSubscriptionPlanName",
  elementPanelSettings: {
    displayName: "Current Subscription Plan Name",
    displayIcon: "text-alt",
    elementGroup: "currentSubscriptionElements",
    elementType: "element",
  },
  extends: TextElement,
  mixins: [CurrentSubscriptionElementMixin],
  computed: {
    value() {
      return this.currentSubscriptionPlan.name ?? "";
    },
  },
};
</script>
